import { UserAction } from "@brookbush/types";

import Link from "next/link";

import SectionContainer from "~/components/SectionContainer";
import { useUserAction } from "~/hooks";
import useTrackCTA from "~/hooks/useTrackCTA";
import { CPT_PROGRAMS_PAGE } from "~/lib/cpt-programs-page";

const CptStudyCompanion = () => {
	const trackCTA = useTrackCTA();
	const { setUserAction } = useUserAction();

	return (
		<SectionContainer className="flex max-w-4xl flex-col gap-6 border-b bg-sky-50/60 dark:bg-sky-900/10">
			<div className="mx-auto flex max-w-3xl flex-col gap-3 text-center">
				<h2 className="font-bold text-2xl sm:text-3xl lg:text-4xl">
					Our honest recommendation: the perfect study companion
				</h2>
				<p className="text-base sm:text-lg lg:text-xl">
					Start with the BI-CPT. Then use everything we built to get you ready
					for the exam — all included in membership:
				</p>
			</div>

			<ul className="mx-auto flex w-full max-w-3xl flex-col gap-4 text-base sm:text-lg">
				<li>
					<strong>The Study Plan</strong> — our courses in the order that covers
					the exam&apos;s content outline.{" "}
					<Link
						href={CPT_PROGRAMS_PAGE.studyPlanHref}
						className="font-medium text-sky-700 hover:underline dark:text-sky-300"
					>
						View the Study Plan →
					</Link>
				</li>
				<li>
					<strong>The Practice Exam</strong> — 100 questions drawn at random
					from a larger bank, so it never goes stale, in a format that feels
					like exam day before exam day.
				</li>
				<li>
					<strong>The Exam Coach</strong> — after each practice exam, it reads
					your results and tells you exactly which courses to study next. Not
					&quot;study more.&quot; Which courses.
				</li>
			</ul>

			<p className="mx-auto max-w-3xl text-center text-base sm:text-lg">
				Every course you complete earns credit toward your BI-CPT and SPC
				certificates while you prepare. Take the exam when the Practice Exam
				says you&apos;re ready.
			</p>

			<button
				type="button"
				onClick={() => {
					trackCTA(UserAction.SIGN_UP, "CPT Study Companion Membership");
					setUserAction(UserAction.SIGN_UP);
				}}
				className="mx-auto rounded-xl bg-gradient-to-r from-sky-500 to-sky-700 px-5 py-2.5 font-medium text-white hover:brightness-95"
			>
				Become a member →
			</button>
		</SectionContainer>
	);
};

export default CptStudyCompanion;
